module.exports = __webpack_public_path__ + "static/media/music.28878248.png";